<template>
  <!-- 商品复购周期 -->
  <div class="goods_repurchase">
    <div class="contain">
      <div class="search_box">
        <top-title :classType="1" :name="name"></top-title>
        <div style="margin-top: 20px">
          <input-form
            ref="inputForm"
            :pageName="pageName"
            @toParentVal="searchForm"
            :inputData="inputData"
          ></input-form>
        </div>
      </div>
      <div class="tab_box">
        <!-- 按钮 -->
        <div class="btn_all">
          <div class="left">
            <div
              class="btn"
              v-zoom="{ from: pageName, name: '批量营销（今日）' }"
              @click="piLiang(0)"
            >
              <span class="btn_tit">批量营销（今日）</span>
            </div>
            <div
              class="btn"
              v-zoom="{ from: pageName, name: '批量营销（本周）' }"
              @click="piLiang(1)"
            >
              <span class="btn_tit">批量营销（本周）</span>
            </div>
          </div>
          <div class="right" style="margin-top: -6px">
            <el-button
              type="primary"
              class="status_btn status_btn2"
              v-zoom="{ from: pageName, name: '导出' }"
              @click="seacherResultCare"
              >导出</el-button
            >
          </div>
        </div>
        <!-- 表格 -->
        <div>
          <el-table
            :data="tableData"
            style="width: 100%; margin-top: 22px"
            :header-cell-style="{ background: '#fafafa' }"
            v-loading="tableLoading"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column min-width="100px" label="商品">
              <template slot="header">
                <span>商品</span>
                <span
                  class="table-message"
                  v-if="!allShow"
                  @click="allShow = true"
                  >(展开全部)</span
                >
                <span
                  class="table-message"
                  v-if="allShow"
                  @click="allShow = false"
                  >(单行显示)</span
                >
              </template>
              <template v-slot="scope">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="scope.row.itemTitle"
                  placement="top"
                >
                  <div class="hoveTitle" v-show="!allShow">
                    {{ scope.row.itemTitle }}
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow">
                  {{ scope.row.itemTitle }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="numIid" label="SKU ID"></el-table-column>
            <el-table-column prop="buyerCount" label="人数"></el-table-column>
            <el-table-column
              prop="returnBuyerCount"
              label="回购人数"
            ></el-table-column>
            <el-table-column prop="returnPercent" label="回购率">
              <template slot-scope="scope">
                <div>{{ returnPercent(scope.row.returnPercent) }}%</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="buyerRebuyAvgCount"
              label="人均回购次数"
            ></el-table-column>
            <el-table-column
              prop="buyerRebuyAvgDate"
              label="平均回购周期（天）"
            ></el-table-column>
            <el-table-column label="今日到期未购买人数">
              <template slot-scope="scope">
                <div class="field-name">{{ scope.row.todayExceedCount }}</div>
                <div class="button" @click="InstantMarketing(scope.row, 0)">
                  <div class="edit_btn">立即营销</div>
                  <!-- <el-button type="primary" plain size="mini" round @click="InstantMarketing2(scope.row)">立即营销</el-button> -->
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="weekExceedCount" label="本周到期未购买人数">
              <template slot-scope="scope">
                <div class="field-name">{{ scope.row.weekExceedCount }}</div>
                <div class="button" @click="InstantMarketing(scope.row, 1)">
                  <div class="edit_btn">立即营销</div>
                  <!-- <el-button type="primary" plain size="mini" round @click="InstantMarketing2(scope.row)">立即营销</el-button> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            @transferName="CurrentChange"
            :total="totalCount"
          ></pagination>
        </div>
      </div>
    </div>
    <!-- 批量发送短信抽屉 -->
    <send-sms
      :drawer="drawer"
      @close="drawerClose"
      :checkData="checkData"
      taskName="商品复购周期分析"
      :sendType="2"
      :count="checkCount"
      :dataFrom="1"
      :searchForm="searchFormData"
    >
    </send-sms>
  </div>
</template>

<script>
import {
  reBuy,
  getReBuyBuyerPhones,
  reBuyExport,
} from "@/api/analysis/ware-controller";
import topTitle from "@/components/top-title";
import inputForm from "@/components/inputForm";
// import sendSms from '@/views/serviceCenter/send_sms'
import Pagination from "@/components/pagination";
import sendSms from "@/views/serviceCenter/components/sendSms";
import { mapState } from "vuex";
import qs from "qs";
export default {
  components: {
    topTitle,
    inputForm,
    sendSms,
    Pagination,
  },
  data() {
    return {
      pageName: "数据分析-商品回购周期分析",
      drawer: false, // 发送短信抽屉状态控制
      checkData: [],
      checkCount: 0,
      searchFormData: {},

      allShow: false,
      tableLoading: false,
      multipleSelection: [],
      totalCount: 0,
      paginationForm: {
        page: 1,
        pageSize: 10,
      },
      form: [],
      tableData: [],
      inputData: [
        // 表单项
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
        },

        {
          name: "购买人数:",
          iptArr: [
            { val: "buyerCountStart", placeholder: "请输入" },
            { val: "buyerCountEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "人均回购次数:",
          iptArr: [
            { val: "rebuyerAvgCountStart", placeholder: "请输入" },
            { val: "rebuyerAvgCountEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "平均回购周期:",
          iptArr: [
            { val: "rebuyAvgCycleStart", placeholder: "请输入" },
            { val: "rebuyAvgCycleEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "今日到期未购人数:",
          iptArr: [
            { val: "todayExceedCountStart", placeholder: "请输入" },
            { val: "todayExceedCountEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "本周到期未购人数:",
          iptArr: [
            { val: "weekExceedCountStart", placeholder: "请输入" },
            { val: "weekExceedCountEnd", placeholder: "请输入" },
          ],
        },
      ],
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    returnPercent() {
      return function (val) {
        if (val == 0) {
          return 0;
        }
        let num = val * 100 + "";
        // console.log(num);
        if (num.indexOf(".") != -1) {
          let num1 = num.substring(0, num.indexOf("."));
          let num2 = num.substring(num.indexOf("."), num.indexOf(".") + 2);
          return num1 + num2;
        }
        return num;
        // let num1 =

        // let num = val*100+"";
        // return val?num1 + num.slice(num.indexOf('.'),num.indexOf('.')+2):''
      };
    },
  },
  mounted() {
    this.$refs.inputForm.formSearch();
  },
  methods: {
    /**
     * 发送短信抽屉隐藏
     */
    drawerClose() {
      this.drawer = false;
    },
    // 导出
    seacherResultCare() {
      // console.log(this.multipleSelection);
      // if (this.multipleSelection.length==0) {
      //     this.$message.info("请勾选要导出的数据")
      //     return
      // }
      // 勾选数据id
      let idArr = this.multipleSelection.map((item) =>
        Number(item.itemRebuyAnalyzeId)
      );
      // console.log(qs.stringify({ idList:idArr }, { arrayFormat: 'repeat' }));
      let params = this.form;
      // 排空
      for (var i in params) {
        if (params[i] == "" || params[i] == null) {
          delete params[i];
        }
      }
      delete params["size"];
      delete params["current"];
      // console.log(idArr);

      // return
      // let elem = document.createElement("a");
      // elem.style.display = "none";
      // // let url = "/jd-yusms/ware/export/reBuy?"+qs.stringify({...params,...this.paginationForm})+"&"+qs.stringify({ idList:idArr }, { arrayFormat: 'repeat' })
      // let url = "/jd-yusms/ware/export/reBuy?"+qs.stringify({...params,...this.paginationForm})+"&"+"idList="+idArr.join(",")
      // elem.href = url
      // document.body.appendChild(elem);
      // elem.click();
      // reBuyExport({...params,...this.paginationForm})
      this.$http
        .post("/ware/export/reBuy", { idList: idArr }, { responseType: "blob" })
        .then((res) => {
          var blob = new Blob([res.data]);
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = "复购周期分析数据.xlsx"; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        });
    },
    /**
     * 表单查询
     */
    searchForm(form) {
      console.log(form);
      this.form = form;
      this.formss = qs.stringify(form);
      this.tableLoading = true;
      reBuy({
        ...form,
        ...this.paginationForm,
      }).then((res) => {
        console.log(res.data);
        this.tableLoading = false;
        (this.tableData = res.data),
          (this.totalCount = Number(res.data[0].total));
      });
    },
    /**
     * 分页查询
     */
    CurrentChange(event) {
      console.log(event);
      this.paginationForm.page = event.current;
      this.paginationForm.pageSize = event.pageSize;
      this.$refs.inputForm.formSearch();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /**
     * 批量营销
     */
    piLiang(type) {
      if (this.multipleSelection.length === 0) {
        this.$message.error("您还未勾选，请进行勾选，再继续操作!");
        return;
      }
      let arr = this.multipleSelection.map((item) => {
        return item.itemRebuyAnalyzeId;
      });
      this.getReBuyBuyerPhones(arr.join(","), type);

      // this.drawer=true
    },

    // 立即营销
    InstantMarketing(item, type) {
      let itemIds = item.itemRebuyAnalyzeId;
      if (item.todayExceedCount == 0 && type == 0) {
        this.$message.warning("今日到期人数为0");
        return;
      }
      if (item.weekExceedCount == 0 && type == 1) {
        this.$message.warning("本周到期人数为0");
        return;
      }
      this.getReBuyBuyerPhones(itemIds, type);
    },
    getReBuyBuyerPhones(itemIds, type) {
      getReBuyBuyerPhones({
        itemIds,
        phoneType: type,
      }).then((res) => {
        if (res.code == 1) {
          // window.localStorage.setItem("mobile",res.data.join(","))

          var list = res.data;
          this.checkData = list;
          this.checkCount = list.length;
          // 跳转到客户营销-指定号码发送

          this.drawer = true;
          // let routeUrl = this.$router.resolve({
          //     path: "/marketing/marketing/designated_send",
          //     query:{id:78}
          // });
          // window.open(routeUrl.href, "_blank");
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.goods_repurchase {
  margin-top: 10px;
  .contain {
    box-sizing: border-box;
    padding: 0 20px;
    min-width: 1106px;
    .search_box {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      padding: 0px 0 30px 0;
      border-radius: 6px;
    }
    .tab_box {
      margin-top: 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      padding: 24px 20px 20px 20px;
      border-radius: 6px;
      .edit_btn {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      .btn_all {
        display: flex;
        margin-bottom: -5px;
        justify-content: space-between;
        .btn {
          box-sizing: border-box;
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          border-radius: 3px;
          margin-right: 8px;
          cursor: pointer;
          height: 32px;
          line-height: 20px;
          .btn_tit {
            height: 32px;
            border-radius: 3px;
            padding: 5px 12px 5px 12px;
            vertical-align: middle;
            color: #ffffff;
            background-color: #fe4d45;
            &:hover {
              color: #fff;
              opacity: 0.9;
              background-color: #fe4d45;
            }
          }
          .btn_tit1 {
            border-radius: 3px;
            padding: 5px 12px 5px 12px;
            vertical-align: middle;
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff;
            &:hover {
              color: #fff;
              border: 1px solid #fff;
              background-color: #fe4d45;
            }
          }
        }
        .status_btn {
          width: 98px;
          // height: 32px;
          background-color: #fff;
          font-size: 14px;
        }
        .status_btn2 {
          margin-left: 20px;
          vertical-align: middle;
          border-radius: 3px;
          width: 98px;
          height: 32px;
          color: #666666;
          border: 1px solid #dddddd;
          background-color: #fff;
          &:hover {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }
      }
      .table-message {
        cursor: pointer;
        color: #7f85e9;
      }
      .hoveTitle {
        text-align: left;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
